import { render, staticRenderFns } from "./HighlightedDocuments.vue?vue&type=template&id=7bb4933e&"
import script from "./HighlightedDocuments.vue?vue&type=script&lang=js&"
export * from "./HighlightedDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports